import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './part/images/header.png'
import _imports_1 from '@/assets/images/header.png'


const _withScopeId = n => (_pushScopeId("data-v-14f2cffa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mas-preview" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "item"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_6 = { class: "msg" }
const _hoisted_7 = { class: "word" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_9 = {
  key: 0,
  class: "msg"
}
const _hoisted_10 = { class: "image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "msg"
}
const _hoisted_13 = { class: "word-and-image" }
const _hoisted_14 = { class: "sub-content" }
const _hoisted_15 = { class: "video-image" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-bofang" }, null, -1))
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "msg fill"
}
const _hoisted_19 = { class: "word-and-image" }
const _hoisted_20 = { class: "sub-content link" }
const _hoisted_21 = { class: "link-title" }
const _hoisted_22 = { class: "link-img" }
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 3,
  class: "msg fill"
}
const _hoisted_25 = { class: "word-and-image" }
const _hoisted_26 = { class: "sub-content applet" }
const _hoisted_27 = { class: "applet-title" }
const _hoisted_28 = { class: "applet-img" }
const _hoisted_29 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.list.content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.list.content), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.attachmentList, (data, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: key
        }, [
          _hoisted_8,
          (data.type === 'image')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", {
                    src: `${_ctx.config?.imgApi}${data.resourceId}`
                  }, null, 8, _hoisted_11)
                ])
              ]))
            : _createCommentVNode("", true),
          (data.type === 'video')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("img", {
                        src: `${_ctx.config?.imgApi}${data.resourceId}`
                      }, null, 8, _hoisted_17)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (data.type === 'link')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", null, _toDisplayString(data.title), 1),
                      _createElementVNode("p", null, _toDisplayString(data.desc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("img", {
                        src: `${_ctx.config?.imgApi}${data.resourceId}`
                      }, null, 8, _hoisted_23)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (data.type === 'miniprogram')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(data.title), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("img", {
                        src: `${_ctx.config?.imgApi}${data.resourceId}`
                      }, null, 8, _hoisted_29)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}